import React, { useState } from 'react'
import {
  EntryPage,
  PasswordRecoveryForm,
  useTenant
} from '@emerald-works-nova/auth'
import { Auth } from '@aws-amplify/auth'
import { entrySlice } from '../../reducers'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { useAlert } from '../../hooks'
import { Grid } from '@mui/material'
import AuthLayout from '../../components/auth/auth-layout'

const PasswordRecoveryPage = () => {
  const [isResetting, setIsResseting] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const tenant = useTenant()
  const { enqueueMsg } = useAlert()
  const verifyUrl = window.location.href.match(/\/\/(?<base>.+?)\//).groups.base
  const [getUserIDByEmail] = useEvent([
    {
      eventName: 'cognitoGetUserIDByEmail',
      onSuccess: recoveryPasswordForUsername,
      onError: handleError
    }
  ])

  const handleRecoverySuccess = (email) => {
    dispatch(entrySlice.actions.emailSent(email))
    navigate('/password-recovered')
    setIsResseting(false)
  }

  const [sendForgotPasswordEmail] = useEvent([{
    eventName: 'userSendForgotPasswordEmail',
    onSuccess: (email) => {
      handleRecoverySuccess(email)
    },
    onError: handleError
  }])

  function handleError (e) {
    enqueueMsg('Unable to reset password', 'error')
    setIsResseting(false)
  }

  async function recoveryPasswordForUsername (payload) {
    const { Username, Email } = payload
    if (Username) {
      try {
        const success = await Auth.forgotPassword(Username, { verifyUrl })
        if (success) {
          handleRecoverySuccess(Email)
        }
      } catch (err) {
        handleError(err)
      }
    } else {
      // handle pre migrated, users not in cognito
      sendForgotPasswordEmail.trigger({
        email: Email,
        verifyUrl
      })
    }
  }

  function handleRecoverPassword (data) {
    setIsResseting(true)
    getUserIDByEmail.trigger({
      email: data.email,
      userPoolId: tenant.userPoolId
    })
  }

  if (!tenant) return null

  return (
    <AuthLayout>
      <Grid container direction='column' wrap='nowrap'>
        <Grid item style={{ marginTop: 85 }}>
          <EntryPage
            title={`Password recovery for ${tenant?.name || 'Mindtools'}`}
            showMtLogo
            subtitle='If you have forgotten your password you can reset it here'
            content={
              <PasswordRecoveryForm
                onRecoverPassword={handleRecoverPassword}
                isResetting={isResetting}
              />
            }
          />
        </Grid>
      </Grid>
    </AuthLayout>
  )
}

export {
  PasswordRecoveryPage as Component
}
